// src/pages/about.jsx
import React from 'react';
import '../styles/style.css';
import ShapesBackground from '../components/shapesbackground';
import SectionHeading from '../components/sectionheading';
import Card from '../components/card';
import CardContainer from '../components/cardcontainer';
import Footer from '../components/footer';
import SelalLogo from '../assets/logo/Selal_About.jpg';
import Hero from '../components/hero';
import { useLang } from '../context/langcontext';

// What Drives Us Icons
import visionIcon from '../assets/icons/vision.png';
import missionIcon from '../assets/icons/mission.png';
import objectivesIcon from '../assets/icons/objectives.png';
import visionIconAr from '../assets/icons/visionar.png';
import missionIconAr from '../assets/icons/missionar.png';
import objectivesIconAr from '../assets/icons/objectivesar.png';

// Our Values Icons
import diversityIcon from '../assets/icons/diversity.png';
import qualityIcon from '../assets/icons/quality.png';
import developmentIcon from '../assets/icons/development.png';
import commitmentIcon from '../assets/icons/commitment.png';
import diversityIconAr from '../assets/icons/diversityar.png';
import qualityIconAr from '../assets/icons/qualityar.png';
import developmentIconAr from '../assets/icons/developmentar.png';
import commitmentIconAr from '../assets/icons/commitmentar.png';

// Why Choose Selal Icons
import varietyIcon from '../assets/icons/variety.png';
import offersIcon from '../assets/icons/offers.png';
import paymentIcon from '../assets/icons/payment.png';
import fastIcon from '../assets/icons/fast.png';

const About = () => {
  const langContext = useLang();
  const { t } = langContext;
  
  // Try to get language from different possible property names
  const language = langContext.language || langContext.lang || langContext.currentLanguage || 'en';
  
  console.log('Full context:', langContext);
  console.log('Language value:', language);
  
  // More flexible language detection
  const isArabic = language && (
    language === 'ar' || 
    language === 'arabic' || 
    language.toLowerCase() === 'ar' ||
    language.toLowerCase() === 'arabic' ||
    language.startsWith('ar')
  );
  
  console.log('Is Arabic:', isArabic);
  
  // Select icons based on language
  const visionImg = isArabic ? visionIconAr : visionIcon;
  const missionImg = isArabic ? missionIconAr : missionIcon;
  const objectivesImg = isArabic ? objectivesIconAr : objectivesIcon;
  
  const diversityImg = isArabic ? diversityIconAr : diversityIcon;
  const qualityImg = isArabic ? qualityIconAr : qualityIcon;
  const developmentImg = isArabic ? developmentIconAr : developmentIcon;
  const commitmentImg = isArabic ? commitmentIconAr : commitmentIcon;
  
  console.log('Selected vision image:', visionImg);
  
  return (
    <>
      {/* Animated Background */}
      <ShapesBackground />
      
      {/* Hero */}
      <Hero
        heroImage={require('../assets/phone/about.png')}
        showButtons={true}
        customHeading={t("aboutTitle")}
        customSubtext={t("aboutCustomSubtext")}
        customDescription={t("aboutHeroDescription")}
      />
      
      {/* About Selal Section */}
      <section className="cta-section about-selal" id="about-selal">
        <div className="text-content">
          <h2>{t("aboutTitle")}</h2>
          <p>{t("aboutParagraph1")}</p>
          <p>{t("aboutParagraph2")}</p>
          <p>{t("aboutParagraph3")}</p>
          <p>{t("aboutParagraph4")}</p>
          <p>{t("aboutParagraph5")}</p>
        </div>
        <div className="image-container">
          <img src={SelalLogo} alt="Selal Logo" />
        </div>
      </section>
      
      {/* What Drives Us Section */}
      <section className="what-drives-us" id="what-drives-us">
        <SectionHeading text={t("whatDrivesUsTitle")} />
        <div className="card-container-wrapper">
          <CardContainer>
            <Card className="drives-card">
              <img src={visionImg} alt="Vision" className="card-icon" />
              <p>{t("visionDescription")}</p>
            </Card>
            <Card className="drives-card">
              <img src={missionImg} alt="Mission" className="card-icon" />
              <p>{t("missionDescription")}</p>
            </Card>
            <Card className="drives-card">
              <img src={objectivesImg} alt="Objectives" className="card-icon" />
              <p>{t("objectivesDescription")}</p>
            </Card>
          </CardContainer>
        </div>
      </section>
      
      {/* Our Values Section */}
      <section className="our-values" id="our-values">
        <SectionHeading text={t("ourValuesTitle")} />
        <div className="card-container-wrapper">
          <CardContainer>
            <Card className="values-card">
              <img src={diversityImg} alt="Diversity" className="card-icon-small" />
              <h3>{t("diversityTitle")}</h3>
              <p>{t("diversityDesc")}</p>
            </Card>
            <Card className="values-card">
              <img src={qualityImg} alt="Quality" className="card-icon-small" />
              <h3>{t("qualityTitle")}</h3>
              <p>{t("qualityDesc")}</p>
            </Card>
            <Card className="values-card">
              <img src={developmentImg} alt="Development" className="card-icon-small" />
              <h3>{t("developmentTitle")}</h3>
              <p>{t("developmentDesc")}</p>
            </Card>
            <Card className="values-card">
              <img src={commitmentImg} alt="Commitment" className="card-icon-small" />
              <h3>{t("commitmentTitle")}</h3>
              <p>{t("commitmentDesc")}</p>
            </Card>
          </CardContainer>
        </div>
      </section>
      
      {/* Why Choose Selal Section */}
      <section className="why-choose" id="why-choose">
        <SectionHeading text={t("whyChooseTitle")} />
        <div className="card-container-wrapper">
          <CardContainer>
            <Card className="why-card">
              <img src={varietyIcon} alt="Wide Variety" className="card-icon-small" />
              <h3>{t("wideVarietyTitle")}</h3>
              <p>{t("wideVarietyDesc")}</p>
            </Card>
            <Card className="why-card">
              <img src={offersIcon} alt="Special Offers" className="card-icon-small" />
              <h3>{t("specialOffersTitle")}</h3>
              <p>{t("specialOffersDesc")}</p>
            </Card>
            <Card className="why-card">
              <img src={paymentIcon} alt="Payment Methods" className="card-icon-small" />
              <h3>{t("paymentMethodsTitle")}</h3>
              <p>{t("paymentMethodsDesc")}</p>
            </Card>
            <Card className="why-card">
              <img src={fastIcon} alt="Fast Delivery" className="card-icon-small" />
              <h3>{t("fastDeliveryTitle")}</h3>
              <p>{t("fastDeliveryDesc")}</p>
            </Card>
          </CardContainer>
        </div>
      </section>
      
      {/* Footer */}
      <Footer />
    </>
  );
};

export default About;